import { render, staticRenderFns } from "./AtualizarFaq.vue?vue&type=template&id=d470d3ae&"
import script from "./AtualizarFaq.vue?vue&type=script&lang=js&"
export * from "./AtualizarFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports